export default "__VITE_ASSET__T2E64IIj__"